import { ApolloClient } from '@apollo/client/core';
import { LocalesEnum } from '../generated/operations';
import { ConfigDocument, ConfigQuery } from '../generated/operations';

let controller = new AbortController();

export const fetchConfigOrFail = async (client: ApolloClient<any>, locale: LocalesEnum): Promise<ConfigQuery> => {
  controller.abort();
  controller = new AbortController();
  const {data = null} = await client.query({
    query: ConfigDocument,
    variables: { locale },
    fetchPolicy: 'no-cache',
    context: { fetchOptions: { signal: controller.signal } }
  });
  if (!data) {
    throw new Error(`Can not fetch config for ${locale}`);
  }
  return data;
}
